<script>

import PerPageSelect from "@/components/ui/PerPageSelect.vue";

export default {
    components: {PerPageSelect},
    data() {
        return {
            error: '',
            loading: true,
            downloading: false,
            users: [],
            meta: {
                current_page: 1,
                total: 0,
                per_page: 0,
            },
            sort: {
                field: 'id',
                order: 'desc'
            },
            controller: null,
            perPage: parseInt(localStorage.getItem('perPage_employers') || '10'),
        }
    },
    methods: {
        loadData() {
            this.controller = new AbortController();
            this.loading = true;
            window.scrollTo({top: 0});
            axios.get('/users/employers', {
                signal: this.controller.signal,
                params: {
                    page: this.meta.current_page,
                    per_page: this.perPage,
                    sort: this.sort.field,
                    order: this.sort.order
                }
            }).then(response => {
                this.users = response.data.data;
                this.meta.current_page = response.data.meta.current_page;
                this.meta.total = response.data.meta.total;
                this.meta.per_page = response.data.meta.per_page;
            }).catch(() => {
            }).finally(() => {
                this.loading = false;
            })
        },
        onPageChange(page) {
            this.controller.abort();
            this.meta.current_page = page;
            this.loadData();
        },
        onSort(field, order) {
            this.controller.abort();
            this.sort = {field, order};
            this.loadData();
        },
        onPerPageChange() {
            localStorage.setItem('perPage_employers', String(this.perPage));
            this.meta.current_page = 1;
            this.loadData();
        },
        download() {
            this.downloading = true;
            let params = {
                sort: this.sort.field,
                order: this.sort.order,
                xlsx: 1
            }
            axios({
                url: '/users/employers',
                method: 'GET',
                responseType: 'blob',
                params
            }).then((response) => {
                saveAs(response.data, 'employers.xlsx');
            }).finally(() => {
                this.downloading = false;
            });
        }
    },
    mounted() {
        this.loadData();
    },
    beforeUnmount() {
        this.controller.abort();
    }
}

</script>
<template>
    <div class="employers-index users-index">

        <div class="buttons" v-if="$auth.isEmployer() || $auth.isAdmin()">
            <b-button type="is-link" @click="$router.push({name: 'employers.create'})">
                {{ $t('employers.labels.add_employer') }}
            </b-button>
            <b-button v-if="$auth.isAdmin()"
                      :loading="downloading"
                      type="is-link"
                      icon-left="download"
                      @click="download">
                .xlsx
            </b-button>
        </div>

        <b-table
            :data="loading ? [] : users"
            :loading="loading"

            :paginated="!loading"
            backend-pagination
            :total="loading ? 0 : meta.total"
            :per-page="perPage"
            @page-change="onPageChange"
            :aria-next-label="$t('navigation.next_page')"
            :aria-previous-label="$t('navigation.previous_page')"
            :aria-page-label="$t('navigation.page')"
            :aria-current-label="$t('navigation.current_page')"

            backend-sorting
            sort-icon="arrow-up"
            default-sort-direction="asc"
            :default-sort="['company.name', 'desc']"
            @sort="onSort">

            <template #empty>
                <div v-if="!loading" class="block has-text-grey has-text-centered mb-4 mt-4">
                    {{ $t('employers.labels.no_employers') }}
                </div>
            </template>

            <b-table-column field="email" :label="$t('users.fields.email.name')" sortable v-slot="props">
                {{ props.row.email }}
            </b-table-column>

            <b-table-column field="company.name" :label="$t('companies.fields.name.name')" sortable v-slot="props">
                {{ props.row.company.name }}
            </b-table-column>

            <b-table-column field="company.nip" :label="$t('companies.fields.nip.name')" v-slot="props">
                {{ props.row.company.nip }}
            </b-table-column>

            <b-table-column field="company.city" :label="$t('companies.fields.city.name')" v-slot="props">
                {{ props.row.company.city }}
            </b-table-column>

            <b-table-column field="token_balance" :label="$t('users.fields.token_balance.name')" sortable v-slot="props">
                {{ props.row.token_balance }}
            </b-table-column>

            <b-table-column label="-" v-slot="props">
                <section class="buttons">
                    <b-button type="is-primary" size="is-small" icon-right="eye-outline"
                              @click="$router.push({name: 'employers.view', params: {id: props.row.id}})">
                    </b-button>
                    <b-button type="is-link" size="is-small" icon-right="square-edit-outline"
                              @click="$router.push({name: 'employers.edit', params: {id: props.row.id}})">
                    </b-button>
                </section>
            </b-table-column>
            <template #bottom-left>
                <PerPageSelect v-model="perPage" @change="onPerPageChange" />
            </template>

        </b-table>

        <loader :loading="loading"></loader>
    </div>
</template>
